import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { BaseApi, PathParamKey } from "@/shared/services/base-api";

// リクエストモデル
interface ReferenceGetResponseModel {
  uri: string; // 参照先のURL
}

export class ReferenceApi extends BaseApi {
  pathParamKeys: PathParamKey[] = [
    new PathParamKey("server"),
    new PathParamKey("referenceCode", false),
  ];

  /**
   * パスパラメータのチェックと組み立て
   *
   * @protected
   * @param {{ [key: string]: string }} params
   * @returns {*}  {string}
   * @memberof ReferenceApi
   */
  protected resolvePath(params: { [key: string]: string }): string {
    this.ensurePathParamKeysProvided(params);

    // リクエストサーバ名
    const server = this.pathParamKeys[0].resolve(params);
    // お知らせID
    const referenceCode = this.pathParamKeys[1].resolve(params);

    // Note: companyIDはサーバーサイドで「companies/」の後に埋め込まれる
    const basePath = `${server}/reference/${referenceCode}`;

    return basePath;
  }

  /**
   * URI取得API
   *
   * @memberof ReferenceApi
   */
  public get = async (
    referenceCode: string
  ): Promise<ReferenceGetResponseModel> => {
    // リクエストURL生成
    const path = this.resolvePath({
      [this.pathParamKeys[0].key]: referenceCode,
    });

    // URI取得API実行
    const res = await ApiClient.instance.get<ReferenceGetResponseModel>({
      path: path,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
